import React from 'react';
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"


const CGU = (props) => {

    return (
        <main className="container">
            <section className="section-prods">

                <h2>Conditions Générales d'Utilisation</h2>
                <hr />

                <h3>1. Préambule</h3>
                <p>Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du site web de l'association Court Jus (ci-après "le Site")
                    et des services associés (ci-après "les Services"). En accédant au Site et en utilisant les Services, vous acceptez sans réserve les présentes CGU.</p>

                <h3>2. Définitions</h3>

                <p><strong>Administrateur</strong> : Membre de l'association Court Jus ayant accès au back office pour gérer les inscriptions et commandes.</p>
                <p><strong>Utilisateur</strong> : Toute personne physique utilisant le Site et les Services.</p>
                <p><strong>Contenu</strong> : Toutes les informations, données, textes, images, vidéos, sons, etc., publiés sur le Site.</p>


                <h3>3. Accès au Site et aux Services</h3>
                <p>L'accès au Site et aux Services est gratuit, sauf indication contraire. L'Utilisateur doit disposer d'un accès à Internet et du matériel nécessaire
                    pour utiliser le Site et les Services.</p>

                <h3>4. Propriété Intellectuelle</h3>
                <p>Le Site et son Contenu sont protégés par des droits de propriété intellectuelle. Toute reproduction, représentation, modification, publication, adaptation, totale ou partielle, des éléments du Site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Court Jus.</p>

                <h3>5. Responsabilité</h3>
                <p>Court Jus s'efforce de fournir un Site et des Services de qualité. Cependant, Court Jus ne peut garantir l'exactitude, la fiabilité ou l'exhaustivité des informations et du Contenu disponibles sur le Site. Court Jus ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du Site et des Services.</p>

                <h3>6. Données Personnelles</h3>
                <p>Les données personnelles collectées lors de l'utilisation du Site et des Services sont traitées conformément à la politique de confidentialité de Court Jus. L'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition sur ses données personnelles. Pour exercer ces droits, l'Utilisateur peut contacter Court Jus à l'adresse suivante : <a href="mailto:court.jus.asso@gmail.com">court.jus.asso@gmail.com</a>.</p>

                <h3>7. Modification des CGU</h3>
                <p>Court Jus se réserve le droit de modifier les présentes CGU à tout moment. Les modifications seront notifiées aux Utilisateurs par tout moyen approprié.
                    L'Utilisateur est invité à consulter régulièrement les CGU pour prendre connaissance des éventuelles modifications.</p>

                <h3>8. Droit Applicable et Juridiction Compétente</h3>
                <p>Les présentes CGU sont régies par le droit français. Tout litige relatif à l'interprétation ou à l'exécution des présentes CGU sera soumis à la compétence
                    exclusive des tribunaux de Gap.</p>

                <h3>9. Contact</h3>
                <p>Pour toute question ou demande d'information concernant les présentes CGU, l'Utilisateur peut contacter Court Jus à l'adresse suivante : <a href="mailto:court.jus.asso@gmail.com">court.jus.asso@gmail.com</a>.</p>



            </section>
        </main>
    )
}

export default CGU;